import AbstractComponent from "./abstract-component";


const createTemplate = (text) => {
  return (
    `<li class="product-list-page__appliedFilterItem">
      <button type="button" class="product-list-page__appliedFilterButton" title="Удалить">
        ${text}
        <svg class="" width="10" height="10" aria-hidden="true">
          <use href="sienge/img/sprite.svg#close"></use>
        </svg>
      </button>
    </li>`
  );
};

export default class AppliedFilterMarkComponent extends AbstractComponent {
  constructor({text}) {
    super();

    this._text = text;
  }

  getTemplate() {
    return createTemplate(this._text);
  }

  setClickHandler(handler) {
    this.getElement().querySelector(`.product-list-page__appliedFilterButton`)
    .addEventListener(`click`, handler);
  }
}
